export function mapLevel(levelId: number): string {
  if (levelId == 1) return 'Level: Project'
  if (levelId == 2) return 'Level: Category'
  if (levelId == 3) return 'Level: Group'
  if (levelId == 4) return 'Level: Sub Groups'
  return ''
}